import { CDN_FLAGS_BASE_URL } from '@Utils/constants';

/**
 *
 * @param {string} key
 * @returns {string}
 */
export const CountryFlagName = (key) => {
  if (!key || key.length < 2) return '';

  /**
   * The country code is typically the first two characters of the key
   * even if the key is three-letter code e.g. "AUD" or "INR", we will still use the first two letters for country code.
   *
   */
  const countryCode = key.substring(0, 2).toLowerCase();
  return `${CDN_FLAGS_BASE_URL}/${countryCode}.png`;
};
